import React from 'react';
import { css } from '@emotion/css';
import { color_shades_dark, color_text_default, color_colors_decline, color_text_light, color_shades_darkest, color_colors_gold, color_colors_gold_background, color_colors_ocean } from '../../constants/colors';
import TooltipWrapper from '../general/TooltipWrapper';
import styled from '@emotion/styled';
import Button from '../general/Button';

const alertIcon = require('../../content/images/alert-circle-yellow.svg');

interface FieldCardProps {
    required?: boolean
    tip?: string
    title?: string
    isRecentlyAddedModuleFormField?: boolean
    className?: string
    hasVariations?: boolean
    onSaveVariation?: () => void
    onViewVariations?: () => void
}

const FormFieldCard: React.FC<FieldCardProps> = (props) => {
    return (
        <div className={`${containerStyle} ${props.className}`}>
            <div className="card-header-wrapper">
                <p className="card-title">{props.title}</p>
                <div className="header-actions">
                    {props.onSaveVariation && (
                        <TooltipWrapper text="Save current value as a variation">
                            <VariationButton
                                themes={['secondary-small']}
                                text="Create Variation"
                                type="button"
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    props.onSaveVariation();
                                }}
                            />
                        </TooltipWrapper>
                    )}
                    {props.hasVariations && props.onViewVariations && (
                        <TooltipWrapper text="View and select saved variations">
                            <VariationButton
                                themes={['white-small']}
                                text="View Variations"
                                type="button"
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    props.onViewVariations();
                                }}
                            />
                        </TooltipWrapper>
                    )}
                    {props.required && <TooltipWrapper text="Required field"><p className="required-indicator-label"><span className="required-indicator">*</span></p></TooltipWrapper>}
                </div>
            </div>
            <div className="card-body-wrapper">
                <p className="card-tip">{props.tip}</p>
                {props.children}
                {props.isRecentlyAddedModuleFormField &&
                    <ErrorStyle>
                        <AlertIconStyle src={alertIcon} />
                        Please review this recently added or updated form field. Edit the the value or to accept the default, simply select the 'Save & Next' button above.
                    </ErrorStyle>
                }
            </div>
        </div>
    );
};

const ErrorStyle = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-family: Muli, "sans-serif";
    font-weight: normal;
    color: ${color_shades_darkest};
    background-color: ${color_colors_gold_background};
    border: 1px solid ${color_colors_gold};
    border-radius: 8px;
    flex-grow: 1;
    padding: 8px 16px;
    margin: 8px 0;
    font-size: 14px;
`;

const AlertIconStyle = styled.img`
    margin-right: 8px;
`;

const VariationButton = styled(Button)`
    margin-left: 0px;
    font-size: 12px;
    padding: 4px 12px;
    height: auto;
    min-height: auto;
`;

const containerStyle = css`
    background: white;
    border: 1px solid ${color_shades_dark};
    box-sizing: border-box;
    border-radius: 8px;
    padding: 32px;
    .card-header-wrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: ${color_text_default};
        padding-bottom: 16px;
        border-bottom: 1px solid ${color_shades_dark};
        .card-title {
            font-style: normal;
            font-weight: normal;
            font-size: 18px;
            line-height: 24px;
            flex: 1;
        }
        .header-actions {
            display: flex;
            align-items: center;
            gap: 8px;
            margin-left: 16px;
        }
        .required-indicator-label {
            font-style: normal;
            font-weight: normal;
            font-size: 12px;
            margin: 0;
            .required-indicator {
                font-style: normal;
                font-weight: normal;
                font-size: 24px;
                color: ${color_colors_decline};
            }
        }
    }
    .card-tip {
        margin: 16px 0;
        color: ${color_text_light};
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 20px;
    }
`;

export default FormFieldCard;